import is from '@sindresorhus/is';

import type { TileAvailability, TileRoutePolicy } from './types';

export type TileDeclaringRouteDefinition = {
    readonly path: string;
    readonly tiles?: readonly TileAvailability[];
};

export const collectTileRoutePolicies = ({
    explicitPolicies,
    routeDefinitions,
}: {
    readonly explicitPolicies: readonly TileRoutePolicy[];
    readonly routeDefinitions: readonly TileDeclaringRouteDefinition[];
}): readonly TileRoutePolicy[] => {
    const routeDefinitionPolicies = routeDefinitions.flatMap((routeDefinition) => {
        const tiles = routeDefinition.tiles ?? [];

        return is.emptyArray(tiles) ? [] : [{ pattern: routeDefinition.path, tiles }];
    });

    return [...routeDefinitionPolicies, ...explicitPolicies];
};
